import React from 'react';
import { useAtomValue } from 'jotai';
import { Navigate, useLocation } from 'react-router-dom';
import { authState } from '../store/atoms';

interface PublicRouteProps {
  children: React.ReactNode;
  redirectTo?: string;
}

const PublicRoute: React.FC<PublicRouteProps> = ({ children, redirectTo }) => {
  const auth = useAtomValue(authState);
  const location = useLocation();

  // 이미 로그인된 사용자인 경우
  if (auth.isAuthenticated) {
    // 리다이렉트할 경로가 지정된 경우 해당 경로로
    if (redirectTo) {
      return <Navigate to={redirectTo} replace />;
    }

    // 현재 페이지가 로그인 또는 비밀번호 재설정 페이지인 경우에만 리다이렉트
    if (location.pathname === '/login' || location.pathname === '/forgot-password') {
      // 사용자 타입에 따라 적절한 대시보드로 리다이렉트
      if (auth.userType === 'teacher') {
        return <Navigate to="/admin/dashboard" replace />;
      } else if (auth.userType === 'user') {
        return <Navigate to="/user/dashboard" replace />;
      }
    }
  }

  return <>{children}</>;
};

export default PublicRoute;
